/** Customer copy for schedule setup in the onboarding wizard. */

export const SCHEDULE_SEASON_ROLLOVER_COPY =
  'When NeonSportz starts a new season, review and apply an import to update LSC. The active week will not advance automatically from source sync alone.';

export const SCHEDULE_SETUP_INTRO_COPY =
  'Connect NeonSportz or import a CSV to load games for your league. After import, LSC shows your active season and week for live detection and archive matching.';

export const SCHEDULE_SOURCE_STALE_REPAIR_COPY =
  'LSC flagged your schedule source as out of date even though your active week may already match. Refresh schedule status after you import or apply an updated schedule.';

export const SCHEDULE_SOURCE_STALE_REPAIR_CTA = 'Refresh schedule status';

export const SCHEDULE_SOURCE_STALE_REPAIR_SUCCESS_COPY =
  'Schedule status refreshed. Live automation can proceed when other readiness checks pass.';

export const SCHEDULE_SOURCE_STALE_ROLLOVER_COPY =
  'NeonSportz shows a new season. Import the updated schedule, review it, and apply before LSC can refresh schedule state.';

export const SCHEDULE_SYNC_ROLLOVER_DETECTED_COPY =
  'New season schedule detected. Review the import preview and apply when ready. Source sync will not advance LSC into a new season automatically.';

export const SCHEDULE_SYNC_ROLLOVER_REVIEW_COPY =
  'This update may replace or advance your league schedule. We keep automation paused for this schedule source until review is complete.';

export const SCHEDULE_SYNC_SAME_SEASON_ALIGNED_COPY =
  'Same-season schedule is aligned.';

export const SCHEDULE_SYNC_TEAM_ASSIGNMENT_REVIEW_COPY =
  "Team assignments need review before this schedule can be applied.";

export function scheduleTeamAssignmentNextStepCopy(mismatchCount: number): string {
  if (mismatchCount === 1) {
    return "1 member's team changed. Review before finishing.";
  }
  if (mismatchCount > 1) {
    return `${mismatchCount} members' teams changed. Review before finishing.`;
  }
  return SCHEDULE_SYNC_TEAM_ASSIGNMENT_REVIEW_COPY;
}

export const SCHEDULE_IMPORT_EDITION_FIRST_ACK_COPY =
  "This import is Madden 27. Your league's earlier seasons don't have a Madden year on record. Confirm this is a new game year. Your earlier seasons and archives stay as they are.";

export const SCHEDULE_IMPORT_EDITION_ROLLOVER_ACK_COPY =
  'This starts a new Madden season. Your earlier seasons and archives stay as they are.';

export const PROVIDER_LINK_BROKEN_COPY =
  'Your NeonSportz league link stopped working. This usually means your league moved to a new Madden year.';

export const PROVIDER_LINK_WAITING_FOR_M27_COPY =
  "Waiting for your Madden 27 league on NeonSportz — paste the link once it's created";

export const PROVIDER_LINK_HELD_FOR_REVIEW_COPY = 'Schedule changes are waiting on your review.';

export const SCHEDULE_IMPORT_ROLLOVER_ACK_COPY =
  'I reviewed this new season schedule and want to apply it to LSC.';

export const SCHEDULE_SOURCE_STALE_REVIEW_COPY =
  'NeonSportz week or stage differs from LSC. Sync from NeonSportz, review the preview, and apply when ready.';

export const GUARDED_AUTO_SYNC_APPLY_OFF_COPY = 'Auto-sync apply is off.';
export const GUARDED_AUTO_SYNC_APPLY_DRY_RUN_COPY =
  'Auto-sync is preview/dry-run only. Nothing is applied automatically.';
export const GUARDED_AUTO_SYNC_APPLY_SAFE_OPT_IN_COPY =
  'Turn on Keep my schedule current to apply score and week updates automatically.';
export const GUARDED_AUTO_SYNC_APPLY_SAFE_ON_COPY =
  'Safe auto-apply is on for scores and week changes. Season changes still wait for review.';
export const GUARDED_AUTO_SYNC_APPLY_PREVIEW_READY_COPY =
  'Same-season update is ready to review before applying.';
export const GUARDED_AUTO_SYNC_APPLY_ELIGIBLE_COPY = 'Same-season update is ready to apply.';
export const GUARDED_AUTO_SYNC_APPLY_BLOCKED_ROLLOVER_COPY =
  'New season detected. Review the schedule before applying.';
export const GUARDED_AUTO_SYNC_APPLY_BLOCKED_STALE_COPY =
  'This update needs review before it can be applied.';
export const GUARDED_AUTO_SYNC_APPLY_BLOCKED_TEAM_COPY =
  'Team assignments need review first.';
export const GUARDED_AUTO_SYNC_APPLY_BLOCKED_SOURCE_COPY =
  'We could not refresh this schedule source.';
export const GUARDED_AUTO_SYNC_APPLY_BLOCKED_BILLING_COPY =
  'Billing or permissions are blocking schedule automation.';

export function guardedAutoSyncApplyCustomerCopy(mode?: string | null): string {
  switch (mode) {
    case 'auto_sync_apply_dry_run':
      return GUARDED_AUTO_SYNC_APPLY_DRY_RUN_COPY;
    case 'auto_sync_safe_apply_opt_in':
      return GUARDED_AUTO_SYNC_APPLY_SAFE_OPT_IN_COPY;
    case 'auto_sync_safe_apply_on':
      return GUARDED_AUTO_SYNC_APPLY_SAFE_ON_COPY;
    case 'auto_sync_apply_preview_ready':
      return GUARDED_AUTO_SYNC_APPLY_PREVIEW_READY_COPY;
    case 'auto_sync_apply_eligible':
      return GUARDED_AUTO_SYNC_APPLY_ELIGIBLE_COPY;
    case 'auto_sync_apply_blocked_rollover':
      return GUARDED_AUTO_SYNC_APPLY_BLOCKED_ROLLOVER_COPY;
    case 'auto_sync_apply_blocked_stale':
    case 'auto_sync_apply_blocked_review_required':
      return GUARDED_AUTO_SYNC_APPLY_BLOCKED_STALE_COPY;
    case 'auto_sync_apply_blocked_team_assignments':
      return GUARDED_AUTO_SYNC_APPLY_BLOCKED_TEAM_COPY;
    case 'auto_sync_apply_blocked_source_unavailable':
      return GUARDED_AUTO_SYNC_APPLY_BLOCKED_SOURCE_COPY;
    case 'auto_sync_apply_blocked_billing':
    case 'auto_sync_apply_blocked_permission':
      return GUARDED_AUTO_SYNC_APPLY_BLOCKED_BILLING_COPY;
    case 'auto_sync_apply_off':
    default:
      return GUARDED_AUTO_SYNC_APPLY_OFF_COPY;
  }
}
